import React, { useEffect } from 'react';
import { Button, Flex } from 'antd';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';

import { useApiErrorNotification } from '../../../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../../../hooks/useApiSuccessNotification';
import { renderField } from '../../../../promocodes/utils/fields';
import { fields, initialValues, validationSchema } from '../fields';
import {
    useLazyReadCloudPaymentsQuery,
    useUpdateCloudPaymentsMutation,
} from '../../../service/paymentSettings.api';
import { FORM_WIDTH, formikCommonOptions } from '../../../utils/options';

export const CloudpaymentsStepConnect = () => {
    const { id } = useParams();

    const [
        createCloudPayments,
        { isSuccess, isLoading: isLoadingCreate, isError, error, data },
    ] = useUpdateCloudPaymentsMutation();

    const [getCloudPayments, { isSuccess: isSuccessRead, data: values }] =
        useLazyReadCloudPaymentsQuery();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data);

    useEffect(() => {
        if (id) {
            getCloudPayments(+id, true);
        }
    }, [id]);

    const onSubmit = async values => {
        const payload = {
            shop_id: +id,
            ...values,
        };

        await createCloudPayments({ ...payload });
    };

    const formik = useFormik({
        initialValues: { ...values } || initialValues,
        validationSchema,
        onSubmit: onSubmit,
        ...formikCommonOptions,
    });

    return (
        <Flex vertical gap={8}>
            <Flex vertical style={{ width: FORM_WIDTH }} gap={8}>
                {fields.map(field => (
                    <React.Fragment key={field.name}>
                        {renderField(field, formik)}
                    </React.Fragment>
                ))}
            </Flex>

            <div>
                <Button
                    disabled={!formik.isValid || !formik.dirty}
                    onClick={() => onSubmit(formik.values)}
                >
                    Сохранить
                </Button>
            </div>
        </Flex>
    );
};
